import { ImportJobStatus, ImportType } from 'common/types/Entities';

import { _request, APIBaseResponse, APIMethod } from '../';
import { buildQueryParams } from '../apiHelpers';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const IMPORTS_PATH_PREFIX = '/imports';
const TYPES_PATH_PREFIX = 'types';
const JOBS_PATH_PREFIX = 'jobs';

export type APIImportJobPostParams = RequestParamsBase & {
    tenantId?: string,
    importType: string,
    formData: FormData
};

export type APIGetImportJobStatusParams = RequestParamsBase & {
    importJobId: string
};

export type APIImportJobPostResponse = APIBaseResponse<string>;
type APIGetImportJobStatusResponse = APIBaseResponse<ImportJobStatus>;
type APIImportTypesGetResponse = APIBaseResponse<Array<ImportType>>;

export const APIImportTypesGetList: APIMethod<void ,APIImportTypesGetResponse> = () => (
    _request('GET', `${IMPORTS_PATH_PREFIX}/${TYPES_PATH_PREFIX}`)
);

export const APIImportJobPost: APIMethod<APIImportJobPostParams, APIImportJobPostResponse> = (params: APIImportJobPostParams) => {
    const queryParams = buildQueryParams({ importType: params.importType });
    const tenantIdQueryPortion = params.tenantId ? `tenantId=${params.tenantId}&` : '';
    return _request(
        'POST',
        `${IMPORTS_PATH_PREFIX}/${JOBS_PATH_PREFIX}?${tenantIdQueryPortion}${queryParams}`,
        params.formData
    );
};

export const APIGetImportJobStatus: APIMethod<APIGetImportJobStatusParams, APIGetImportJobStatusResponse> = (params: APIGetImportJobStatusParams) => (
    _request('GET', `${IMPORTS_PATH_PREFIX}/${JOBS_PATH_PREFIX}/${params.importJobId}`)
);
